import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { Box } from "@mui/material";
import { useLoader } from "../components/common/LoaderContext";

const Loader: React.FC = () => {
  const { loading } = useLoader();

  if (!loading) return null; // 🔹 Only show loader when loading is true

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "rgba(255, 255, 255, 0.7)",
        zIndex: 9999,
      }}
    >
      <CircularProgress size={50} />
    </Box>
  );
};

export default Loader;
